// The existing HTML Google tag owns initialization and automatic page views.
// Custom events contain fixed labels only: never form values or contact URLs.
const MEASUREMENT_ID = "G-NSZ6SGSQNQ";
const CONTACT_TRACKING_KEY = "__tosContactAnalyticsCleanup";
const NOOP = () => {};

function isProductionHost() {
  return typeof window !== "undefined" &&
    ["touroperatorservices.com", "www.touroperatorservices.com"].includes(window.location.hostname);
}

function sendEvent(name, parameters) {
  try {
    if (!isProductionHost() || typeof window.gtag !== "function") return false;
    window.gtag("event", name, { send_to: MEASUREMENT_ID, ...parameters });
    return true;
  } catch {
    // Analytics must never change the result of an enquiry or a contact click.
    return false;
  }
}

export function trackGenerateLead(formPlacement) {
  return sendEvent("generate_lead", {
    lead_source: "website_enquiry",
    form_placement: ["contact", "modal"].includes(formPlacement) ? formPlacement : "other",
  });
}

export function installContactClickTracking() {
  try {
    if (!isProductionHost() || !window.document) return NOOP;
    const doc = window.document;
    if (typeof doc[CONTACT_TRACKING_KEY] === "function") return doc[CONTACT_TRACKING_KEY];

    const onClick = (event) => {
      try {
        if (event.defaultPrevented || (typeof event.button === "number" && event.button !== 0)) return;
        const target = event.target?.nodeType === 3 ? event.target.parentElement : event.target;
        const anchor = target?.closest?.("a[href]");
        if (!anchor) return;
        const url = new URL(anchor.getAttribute("href"), doc.baseURI);
        if (url.protocol === "tel:") {
          sendEvent("click_call", { contact_method: "phone" });
        } else if (url.protocol === "whatsapp:" ||
          (["https:", "http:"].includes(url.protocol) &&
            ["wa.me", "api.whatsapp.com", "web.whatsapp.com"].includes(url.hostname))) {
          sendEvent("click_whatsapp", { contact_method: "whatsapp" });
        }
      } catch {
        // Preserve normal navigation even for malformed links or blocked tags.
      }
    };

    let removed = false;
    const cleanup = () => {
      if (removed) return;
      removed = true;
      try {
        doc.removeEventListener("click", onClick);
        if (doc[CONTACT_TRACKING_KEY] === cleanup) delete doc[CONTACT_TRACKING_KEY];
      } catch {
        // Teardown must remain safe during hot reload or document disposal.
      }
    };
    doc[CONTACT_TRACKING_KEY] = cleanup;
    try {
      // Delegation also covers SPA pages and enquiry links rendered later.
      doc.addEventListener("click", onClick);
    } catch {
      cleanup();
      return NOOP;
    }
    return cleanup;
  } catch {
    return NOOP;
  }
}
